import React from 'react'

import Nav from '../nav/Nav';
import HeaderImage from '../../assets/header_image.svg'
import PolygonImage from '../../assets/polygon.svg'
import EllipseImage from '../../assets/ellipse.svg'
import CrossImage from '../../assets/cross.svg'

import './Header.scss'

const Header = () => {
  return (
    <section className='header mt-0'>
        {/* ========= Circles ============= */} 
        <div className="dim__circle left__circle"></div>
        <div className="dim__circle right__circle"></div>

        {/* ========= Hovering Icons ============= */}
        <img src={PolygonImage} alt="Hovering Icon" className='image__polygon__header'/>
        <img src={EllipseImage} alt="Hovering Icon" className='image__ellipse__header'/>
        <img src={CrossImage} alt="Hovering Icon" className='image__cross__header'/>

        <div className='container'>
            <div className="header__content">
                <div>
                    <article className='header__heading'>Building technology that drives business success</article>
                    <article className='header__details'>Committed to providing innovative products and exceptional customer service to provide outstanding customer experience</article>

                    <a href="#contact-us" className='btn'>Get A Quote</a>
                </div>
                <img src={HeaderImage} alt="Header Image" className='header__img' />
            </div>

        </div>
    </section>
  )
}

export default Header